<template>
  <base-modal
    :modal-title="'Edit Campaign'"
    @close="close()"
    @save="save()"
    class="modal-lg"
  >
    <FormulateForm>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <h3>Details</h3>
          <FormulateInput
            type="text"
            v-model="campaignModel.name"
            name="name"
            label="Name"
            validation="required"
          />
          <FormulateInput
            v-model="campaignModel.provider"
            type="select"
            :options="providers"
            name="provider"
            label="Provider"
            validation="required"
          />
          <FormulateInput
            v-model="campaignModel.campaign_type"
            @change="bidCheck()"
            :options="{
                regular: 'Data Lead',
                transfer: 'Call Transfer',
                appointment: 'Appointment Lead',
                'bookable-appointment': 'Bookable Appointment',
                'ping-post': 'Ping-POST',
                facebook: 'Facebook',
                google: 'Google',
                hubspot: 'Hubspot',
            }"
            type="select"
            label="Type"
          />
        </div>
        <div class="col-xs-12 col-md-6">
          <h3>Status</h3>
          <FormulateInput type="group">
            <FormulateInput
              v-model="campaignModel.current_status.is_active"
              type="checkbox"
              name="is_active"
              label="Active"
            />
            <FormulateInput
              v-model="campaignModel.current_status.is_test"
              type="checkbox"
              name="is_test"
              label="Test"
            />
             <FormulateInput
              v-model="campaignModel.return_grades"
              type="checkbox"
              name="return_grades"
              label="Return Grades"
             />
             <FormulateInput
              v-model="campaignModel.agent_zone_rule"
                 type="select"
                 :options="tagRuleOptions"
              name="agent_zone_rule"
              label="Rule for Agent Zone Matching"
            />
          </FormulateInput>
            <br/>
            <br/>
            <br/>
            <div v-if="campaignModel.campaign_type === 'ping-post'">
            <input @change="valCheck()" type="number" v-model.number="campaignModel.bid" />
            <label for="number">Bid</label>

          </div>
        </div>
      </div>
      <div class="row">
          <h3>Tags</h3>
          <tags-widget :tags="campaignModel.tags"
              @removeTag="removeTag"
              @addTag="addTag">
          </tags-widget>
      </div>

      <div class="row">
        <div v-if="campaigns" class="col-xs-12 col-md-12">
          <h3>Clone from existing campaign</h3>
          <FormulateInput
            type="select"
            v-model="campaignToClone"
            :option-groups="campaigns"
          />
          <FormulateInput
            type="button"
            label="Clone"
            :disabled="!campaignToClone"
            @click="cloneCampaign()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-12">
          <h3>Fields</h3>
          <FormulateInput type="group">
            <table
              v-if="campaignModel.fields.length"
              class="table">
              <thead>
                  <tr>
                      <th colspan="2" class="text-right">Field</th>
                      <th>API Name</th>
                      <th>Type</th>
                      <th>Default Value</th>
                      <th colspan="2"></th>

                </tr>
              </thead>
              <tbody>
                  <template
                    v-for="(f, ix) in campaignModel.fields">
                    <tr :key="`${f.field ? f.field.id : 'empty'}-${ix}-data`">
                      <td class="sort-buttons">
                        <button :disabled="ix == 0" class="btn btn-sm" @click="moveFieldUp(ix)"><i class="fa fa-arrow-up"></i></button>
                        <button :disabled="ix == (campaignModel.fields.length - 1)" class="btn btn-sm" @click="moveFieldDown(ix)"><i class="fa fa-arrow-down"></i></button>
                      </td>
                      <th class="align-middle">
                        <FormulateInput
                          v-if="campaignModel.campaign_type == 'facebook'"
                          type="select"
                          :options="availableFields"
                          v-model="f.field"
                        />
                        <span v-else>{{ f.field ? fieldOptions[f.field].name : "-" }}</span>
                      </th>
                      <td class="align-middle">
                        <FormulateInput type="text" v-model="f.alias" :disabled="campaignModel.campaign_type == 'facebook'" />
                      </td>
                      <td class="align-middle">
                        <span v-if="!f.field"><i>Please select a field</i></span>
                        <FormulateInput v-else type="select" :options="fieldOptions[f.field].campaign_field_type_options" v-model="f.field_type" />
                      </td>
                      <td class="align-middle">
                        <FormulateInput type="text" v-model="f.default_value" />
                      </td>
                      <td class="text-right">
                        <FormulateInput type="button" @click="toggleFieldNotes(ix)"><i class="fa fa-pencil"></i></FormulateInput>
                      </td>
                      <td class="text-right">
                        <FormulateInput
                          label="-"
                          type="button"
                          @click="removeField(ix)" >
                          <i class="fa fa-trash"></i>
                        </FormulateInput>
                      </td>
                    </tr>
                    <tr :key="`${f.field ? f.field.id : 'empty'}-${ix}-notes`" class="field-notes-row" v-if="f.showNotes">
                      <td colspan="7">
                        <FormulateInput type="textarea" v-model="f.notes" label="Notes" />
                      </td>
                    </tr>
                  </template>
              </tbody>
            </table>
            <div class="col-xs-12">
                <h4>Add field</h4>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Type</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <FormulateInput
                                    type="select"
                                    v-model="field"
                                    :options="availableFields"
                                    @input="addFieldChange"
                                    placeholder="Pick a field"
                                />
                            </td>
                            <td>
                                <FormulateInput
                                    type="select"
                                    v-model="field_type"
                                    :disabled="!field"
                                    :options="addFieldTypeOptions"
                                    placeholder="Pick a type"
                                />

                            </td>
                            <td class="text-right">
                              <FormulateInput
                                  type="button"
                                  label="+ Add"
                                  @click="addField()"
                                  :disabled="!field || !field_type"
                              />

                          </td>
                        </tr>
                    </tbody>
                </table>
            </div>
          </FormulateInput>
        </div>
        <div class="col-xs-12">
          <h3>Billing Condition</h3>
          <boolean-expression-widget
            :expression="campaignModel.billing_condition"
            @updateExpression="updateBillingCondition">
          </boolean-expression-widget>
        </div>
        <div class="col-xs-12">
          <h3>Capacity Limits</h3>
          <FormulateInput type="group">
            <table class="table table-borderless">
              <tbody>
                <tr>
                  <th>Hourly</th>
                  <td>
                    <FormulateInput
                      type="number"
                      v-model="campaignModel.capacity.hourly"
                      min="1"
                    />
                  </td>
                  <td>
                    <FormulateInput
                      label="-"
                      type="button"
                      @click="campaignModel.capacity.hourly = null"
                      ><i class="fa fa-trash"></i
                    ></FormulateInput>
                  </td>
                </tr>

                <tr>
                  <th>Daily</th>
                  <td>
                    <FormulateInput
                      type="number"
                      v-model="campaignModel.capacity.daily"
                      min="1"
                    />
                  </td>
                  <td>
                    <FormulateInput
                      label="-"
                      type="button"
                      @click="campaignModel.capacity.daily = null"
                      ><i class="fa fa-trash"></i
                    ></FormulateInput>
                  </td>
                </tr>

                <tr>
                  <th>Weekly</th>
                  <td>
                    <FormulateInput
                      type="number"
                      v-model="campaignModel.capacity.weekly"
                      min="1"
                    />
                  </td>
                  <td>
                    <FormulateInput
                      label="-"
                      type="button"
                      @click="campaignModel.capacity.weekly = null"
                      ><i class="fa fa-trash"></i
                    ></FormulateInput>
                  </td>
                </tr>

                <tr>
                  <th>Monthly</th>
                  <td>
                    <FormulateInput
                      type="number"
                      v-model="campaignModel.capacity.monthly"
                      min="1"
                    />
                  </td>
                  <td>
                    <FormulateInput
                      label="-"
                      type="button"
                      @click="campaignModel.capacity.monthly = null"
                      ><i class="fa fa-trash"></i
                    ></FormulateInput>
                  </td>
                </tr>
              </tbody>
            </table>
          </FormulateInput>
        </div>
      </div>
    </FormulateForm>
  </base-modal>
</template>

<script>
 // Load the full build.

 var _ = require("lodash");
 import YesNo from "components/elements/YesNo";
 import TagsWidget from "components/elements/TagsWidget";
 import BaseModal from "components/modals/BaseModal";
 import BooleanExpressionWidget from 'components/elements/BooleanExpressionWidget';

  export default {
    components: {
      YesNo,
      TagsWidget,
      BaseModal,
      BooleanExpressionWidget
    },
     props: {
      campaign: null,
     },
     data() {
         return {
           fields: [],
           tagRules: [],
           campaigns: null,
           pickedFields: [],
           providers: {},
           campaignToClone: null,
           campaignModel: {
             id: null,
             campaign_type: "regular",
             name: "",
             provider: null,
             current_status: {
               is_active: false,
               is_test: false,
             },
             fields: [],
             capacity: {
               hourly: null,
               daily: null,
               weekly: null,
               monthly: null,
             },
             return_grades: false,
             bid: null,
             tags: [],
             agent_zone_rule: null,
           },
           field: null,
           field_type: null
         };
     },
     computed: {
         fieldOptions() {
             return Object.fromEntries( this.fields.map( x => [x.id, x]));
         },
         addFieldTypeOptions() {
             if (this.field) {
                 return this.fieldOptions[this.field].campaign_field_type_options;
             }
             return null;
         },
         tagRuleOptions() {
             return [{value: null, label: ''}].concat(
                 this.tagRules.map(r => {
                     return {
                         value: r.id,
                         label: r.name
                     }
                 })
             );
         },
         tags: function () {
             return new Set(this.campaignModel.tags.map(t => t.id));
         },
         allFields: function () {
             return this.fields
                        .map((f) => {
                            return { id: f.id, value: f, label: f.name };
                        });
         },
         availableFields: function () {
             var pFs = new Set(this.pickedFields);

             return this.fields
                        .filter((a) => !pFs.has(a.id))
                        .map((a) => {
                            return { value: a.id, label: a.name };
                        });
         },
         notEmpty: function () {
             for (var k in this.pickedFields) {
                 return true;
             }
             return false;
         },
     },
     created() {
         this.fetchFields();
         this.fetchCampaigns();
         this.fetchProviders();
         this.fetchTagRules();
         if (this.campaign) {
             this.fetchCampaign();
         }
     },
     methods: {
         addFieldChange() {
             this.field_type = null;
             if (this.field) {
                 if (this.fieldOptions[this.field].campaign_field_type_options.length == 1) {
                     this.field_type = this.fieldOptions[this.field].campaign_field_type_options[0].value
                 }
             }
         },
         removeField(i) {
             var f = this.campaignModel.fields.splice(i, 1)[0];
             if (f.field) {
                 var j = this.pickedFields.indexOf(f.field);
                 while (j > -1) {
                     this.$delete(this.pickedFields, j);
                     j = this.pickedFields.indexOf(f.field);
                 }
             }
         },
         async fetchCampaigns() {
             var self = this;
             self.campaigns = {};
             const response = await API.campaigns.getList();
             response.data.forEach((item) => {
                 if (item.id != self.campaign) {
                     let vendor = item.provider_name;
                     if (!(vendor in self.campaigns)) {
                         self.$set(self.campaigns, vendor, {});
                     }

                     let provider_campaigns = Object.assign({}, self.campaigns[vendor], {
                         [item.id]: item.name,
                     });

                     self.$set(self.campaigns, vendor, provider_campaigns);
                 }
             });

             if (_.isEmpty(self.campaigns)) {
                 self.campaigns = null;
             }
         },
         async fetchCampaign() {
             var self = this;
             const response = await API.campaigns.read(this.campaign);
             var pFs = new Set();

             if (response.data.current_status === null) {
                 response.data.current_status = { is_active: false, is_test: false };
             }

             if (response.data.capacity === null) {
                 response.data.capacity = {
                     hourly: null,
                     daily: null,
                     weekly: null,
                     monthly: null,
                 };
             }

             self.campaignModel = response.data;

             self.campaignModel.fields.forEach((f) => {
                 if (f.field) {
                     if (self.campaignModel.campaign_type != 'facebook') {
                         pFs.add(f.field);
                     }
                 }
                 f.showNotes = false;
             });

             self.pickedFields = Array.from(pFs);
         },

         cloneCampaign() {
             var self = this;
             var pFs = new Set();
             API.campaigns.read(self.campaignToClone).then(function (response) {
                 self.campaignModel.fields = _.map(
                     response.data.fields,
                     function (f) {
                         pFs.add(f.field.id);
                         return _.clone(f);
                     }
                 );

                 self.campaignModel.readonly_fields = _.map(
                     response.data.readonly_fields,
                     function (f) {
                         pFs.add(f.field.id);
                         return _.clone(f);
                     }
                 );

                 self.campaignModel.campaign_context = _.map(
                     response.data.campaign_context,
                     function (f) {
                         pFs.add(f.field.id);
                         let ctx_f = {
                             field: f.field,
                             value: f.value,
                         };
                         return ctx_f;
                     }
                 );
                 self.pickedFields = Array.from(pFs);
             });
         },
         async fetchProviders() {
             var self = this;
             const response = await API.providers.getList();
             response.data.forEach(function (item) {
                 self.providers[item.id] = item.provider.name;
             });
         },
         async fetchFields() {
             var self = this;
             const response = await API.fields.getList();
             self.fields = response.data;
         },
         async fetchTagRules() {
             var self = this;
             const response = await API.tags.getRuleList();
             self.tagRules = response.data.results;
         },
         addField() {
             this.campaignModel.fields.push({
                 field: this.field,
                 alias: this.fieldOptions[this.field].slug,
                 field_type: this.field_type,
             });

             this.$set(this.pickedFields, this.pickedFields.length, this.field);

             this.field = null;
             this.field_type = null;
         },
         toggleFieldNotes(ix) {
             let currentValue = this.campaignModel.fields[ix];
             currentValue.showNotes = !currentValue.showNotes;
             this.$set(this.campaignModel.fields, ix, currentValue);
         },
         close() {
             this.$emit("close");
         },
         save() {
             var self = this;
             API.campaigns.save(this.campaignModel)
                .then(function (response) {
                    // closing modal
                    self.campaignModel = response.data;
                    self.$emit("close", true);
                });
         },
         bidCheck() {
             //sets bid value to null when campaign type is changed from ping post
             if (this.campaignModel.campaign_type !== "ping-post") {
                 this.campaignModel.bid = null;
             }
         },
         valCheck(){
             //sets bid value to null when the bid input is empty
             if(this.campaignModel.bid === ''){
                 this.campaignModel.bid = null;
             }
             if (this.campaignModel.bid != null) {
                 this.campaignModel.bid = parseFloat(this.campaignModel.bid).toFixed(2);
             }
         },
         removeTag(tag) {
             this.campaignModel.tags = this.campaignModel.tags.filter((t) => t != tag);
         },
         addTag(tag) {
             if (!this.tags.has(tag)) {
                 this.campaignModel.tags.push(tag);
             }
         },
       updateBillingCondition(billingCondition) {
        this.campaignModel.billing_condition = billingCondition;
       },
       moveFieldUp(ix) {
         if (ix <= 0) {
           return;
         }

         const temp = this.campaignModel.fields[ix-1];
         this.$set(this.campaignModel.fields, ix - 1, this.campaignModel.fields[ix]);
         this.$set(this.campaignModel.fields, ix, temp);
       },
       moveFieldDown(ix) {
         if (ix >= this.campaignModel.fields.length - 1) {
           return;
         }

         const temp = this.campaignModel.fields[ix+1];
         this.$set(this.campaignModel.fields, ix + 1, this.campaignModel.fields[ix]);
         this.$set(this.campaignModel.fields, ix, temp);
       }
     },
  };
</script>

<style lang="scss">
table {
    width: 100%;

    td {
        vertical-align: middle;
    }

    tbody {
        tr.field-notes-row {
            td {
                border-top: none;
            }
        }
    }
}

.formulate-input {
  position: relative;
}

.formulate-input .formulate-input-element {
  max-width: initial !important;
}
</style>



// WEBPACK FOOTER //
// CampaignModal.vue?31565e8c